import { Affix, Button, rem } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

interface Props {
    url?: string;
    nativeBack?: boolean;
}

const BackButton: React.FC<Props> = ({ url, nativeBack }) => {
    const navigate = useNavigate();
    return (
        <Affix position={{ top: rem(20), left: rem(20) }}>
            <Button
                leftSection={<IconArrowLeft />}
                component="a"
                variant="subtle"
                onClick={() => {
                    if (nativeBack) {
                        window.history.back();
                        return;
                    }
                    navigate(url ?? `/`);
                }}
            >
                Back
            </Button>
        </Affix>
    );
};

export default BackButton;
